<template>
    <div>
        <h1 class="is-size-5-mobile title">¿Como comprar?</h1>

        <div>
            <div class="level is-mobile">
                <div class="level-left">
                    <div class="level-item">
                        <figure class="image is-64x64">
                            <img src="@/assets/img/home-step1.png" alt=""/>
                        </figure>
                    </div>
                    <div class="level-item">
                        <h1 class="subtitle">Registrate online</h1>
                    </div>
                </div>
            </div>

            <p>
                Registrate en Tallo Verde es fácil, solamente hace click en la opción Crear Cuenta, ingresa tus datos,
                y te enviaremos un email para verificar tu dirección de correo.
            </p>
        </div>

        <div class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <figure class="image is-64x64">
                        <img src="@/assets/img/home-step2.png" alt=""/>
                    </figure>
                </div>
                <div class="level-item">
                    <h1 class="subtitle">Seleccioná tus productos</h1>
                </div>
            </div>
        </div>

        <p>
            Agregá a tu carrito los productos que quieras de nuestra selección de products orgánicos de estación y de
            nuestros productos Gourmet. Cuando termines con tu selección simplemente cliquea el botón de Pagar dentro
            del menú que se despliega en el icono del carrito.
        </p>

        <div class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <figure class="image is-64x64">
                        <img src="@/assets/img/home-step3.png" alt=""/>
                    </figure>
                </div>
                <div class="level-item">
                    <h1 class="subtitle">Elegí la forma de entrega y pago</h1>
                </div>
            </div>
        </div>

        <p>
            Ingresá tus datos de entrega y elegí la opción de horario que te sirva. Nuestras camionetas de reparto tienen
            distintas franjas horarias y días de entrega dependiendo de la zona. Por ultímo elegí como queres pagar, con
            Tarjeta de Crédito directo en nuestra página, con Tarjeta de Crédito o Débito en tu casa o simplemente con
            efectivo.
        </p>

        <div class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <figure class="image is-64x64">
                        <img src="@/assets/img/home-step4.png" alt=""/>
                    </figure>
                </div>
                <div class="level-item">
                    <h1 class="subtitle">Cosechamos tu pedido en el día</h1>
                </div>
            </div>
        </div>

        <p>
            En Tallo Verde madrugamos para cosechar tu pedido el mismo día en que te lo entregamos, así nos aseguramos
            que tus productos estén lo mas frescos posibles para que disfrutes del verdadero sabor de los productos
            orgánicos.
        </p>

        <div class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <figure class="image is-64x64">
                        <img src="@/assets/img/home-step5.png" alt=""/>
                    </figure>
                </div>
                <div class="level-item">
                    <h1 class="subtitle">Recibí tu pedido recién cosechado</h1>
                </div>
            </div>
        </div>

        <p>
            En el día y horario acordado nuestras camionetas te estarán entregando tu pedido en la comodidad de tu
            domicilio. Te pedimos que hagas todo lo posible para poder recibir el pedido en tiempo y forma.
        </p>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                steps: [
                    { title: 'Registrate online', img: '/img/home-step1.png' },
                    { title: '', img: '/img/home-step2.png' },
                    { title: '', img: '/img/home-step3.png' },
                    { title: '', img: '/img/home-step4.png' },
                    { title: '', img: '/img/home-step5.png' },
                ]
            }
        },
    }
</script>

<style lang="scss" scoped>
    .level {
        margin-top: 20px;
    }
</style>